// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.5 2.71717L2 5.9255V21.4999L7.5 19.2326V2.71717Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9.5 18.9095L12.7445 20.8256C11.9618 19.7522 11.5 18.43 11.5 16.9999C11.5 14.6987 12.6958 12.6768 14.5 11.5217V5.09027L9.5 2.13745V18.9095Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 2.49987V11.876C20.897 11.0138 19.5085 10.4999 18 10.4999C17.4837 10.4999 16.9815 10.5601 16.5 10.6738V4.76719L22 2.49987Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M19 15.9999V11.9999H17V15.9999H13V17.9999H17V21.9999H19V17.9999H23V15.9999H19Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-map-add-filled')
export default class MapAddFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-add-filled',
    }
  }
}
